/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// image placeholder - replace with actual asset when available

export default function Automotive() {
  return (
    <>
      {/* CHALLENGES WE SOLVE */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in the Automotive Industry</h2>
          <p className="text-center text-gray-600 mb-10">
            Modern automotive businesses need reliable systems for sales, inventory, service operations and customer engagement.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Inventory & Parts Management</h3>
              <p className="text-gray-600">Accurate stock control, vendor integrations and automated ordering to reduce delays.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Customer Relationship Management</h3>
              <p className="text-gray-600">Centralized CRM, service history, and appointment reminders to increase loyalty and repeat business.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Secure Payments & POS</h3>
              <p className="text-gray-600">PCI-compliant payment systems and integrated invoicing for fast, secure transactions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS + OUTCOMES */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Help Automotive Businesses</h2>
            <ul className="space-y-6 text-gray-600">
              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Integrated Inventory Systems</p>
                  <p className="text-sm">Real-time parts and vehicle inventory tracking across locations.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Efficient Service Operations</p>
                  <p className="text-sm">Digitized workflows, electronic inspections and automated job routing for faster turnaround.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Better Customer Experience</p>
                  <p className="text-sm">Online booking, service updates and transparent invoices to boost trust and referrals.</p>
                </div>
              </li>
            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request a Dealership Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Faster service turnaround</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Improved inventory accuracy</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Secure payment processing</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Higher customer retention</strong></p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Want to modernize your automotive business?</h2>
            <p className="text-gray-600 mt-2">We’ll assess your systems, integrate the right tools and improve efficiency across the board.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Get a Free Assessment</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
